import React, {useEffect} from 'react'
import styles from './DocumentsFileViewerPage.module.css'
import FolderIcon from '@mui/icons-material/Folder';
import ArticleIcon from '@mui/icons-material/Article';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

import {
    useCopyDocuments,
    useDeleteDocuments,
    useDownloadDocuments,
    useFetchDocuments, useMoveDocuments,
    useUploadDocument
} from "../../../queries/useDocuments";
import {
    Avatar, Grid,
    ListItem,
    ListItemAvatar, ListItemButton, ListItemIcon,
    ListItemText,
} from "@mui/material";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, Typography} from "@material-ui/core";
import axios from "axios";
import {ColumnFileViewer} from "../ColumnFileViewer";
import {DataModel} from "../interfaces/FileManagerModels";
import LoadingBackdrop from "../../../components/common/LoadingBackdrop";


export const DocumentsFileViewerPage = ({ woid, reloadTab, isLoading, setIsLoading }) => {
    const [treeStructure, setTreeStructure] = React.useState([])
    const [columnStructure, setColumnStructure] = React.useState([])
    const [copyTree, setCopyTree] = React.useState(null)
    const [watchLogoData, setWatchLogoData] = React.useState(null)
    const [watchLogoDataURL, setWatchLogoDataURL] = React.useState(null)
    const [moveTree, setMoveTree] = React.useState(false)
    const [dataLoaded, setDataLoaded] = React.useState(false)
    const [openViewer, setOpenViewer] = React.useState(false)
    const [reloadColumnViewer, setReloadColumnViewer] = React.useState(0)
    const [handleFileOpen, setHandleFileOpen] = React.useState({id:'', name:''})
    const [itemSelected, setItemSelected] = React.useState<string>('')
    // const {getRootProps, getInputProps, open} = useDropzone({noClick: true})
    const uploadDocument = useUploadDocument(woid)
    const deleteDocument = useDeleteDocuments(woid)
    const downloadDocument = useDownloadDocuments(woid)
    const copyDocument = useCopyDocuments(woid)
    const moveDocument = useMoveDocuments(woid)
    const [expanded, setExpanded] = React.useState<string[]>([]);
    const [dialogMsg, setDialogMsg] = React.useState("")
    const [data, setData] = React.useState({
        contents: [],
        allowstructurerecreate: false,
        status: ''
    });

    const getDocuments = async () => {
        const { data } = await axios.post('/fieldsystemdocumentviewer', {
            woid: woid
        })
        const parsedData = JSON.parse(data.jsonString)
        if (parsedData?.status == 'failure') {
            setDialogMsg(parsedData?.message)
        }
        else {
            setData(parsedData)
        }
        console.log(parsedData)
    }

    useEffect(()=> {
        getDocuments()
    }, [])

    // const { data } = useFetchDocuments(woid)
    useEffect(() => {
        if (data && data.contents && data.contents.length > 0) {
            const processSubitemsNew = (item, path) => {
                if (item.IsFolder) {  // && item?.SubItems?.length > 0) {
                    if (item && item.SubItems?.length > 0) {
                        return item.SubItems.map(subItem => {
                            console.log(subItem)
                            var newStruct = subItem?.SubItems?.length > 0 ? processSubitemsNew(subItem, path + '/' + subItem.Name) : []
                            return {
                                path: path + '/' +  subItem.Name,
                                id: subItem.Id,
                                parentid: subItem.ParentId,
                                isfolder: subItem.IsFolder,
                                rootname: data.contents[0].Name,
                                name: subItem.Name,
                                size: subItem.Size,
                                dateCreated: HumanReadableDate(subItem.CreatedTime),
                                dateModified: HumanReadableDate(subItem.ModifiedTime),
                                items: newStruct,
                                Thumbnail: subItem.Thumbnail,
                                sharedid: subItem.SharedId,
                                issystem: subItem.IsSystem,
                                issaveasbuilt: subItem.IsSaveAsBuilt,
                                allowfolder: subItem.allowfolder,
                                allowdelete: subItem.allowdelete,
                                allowsave: subItem.allowsave,
                                allowcopy: subItem.allowcopy,
                                allowmove: subItem.allowmove,
                                allowpaste: subItem.allowpaste,
                                allowrename: subItem.allowrename,
                                allowdownload: subItem.allowdownload,
                                allowupload: subItem.allowupload,
                            }
                        })
                    }
                }
            }

            const dataStructFinal = processSubitemsNew(data.contents[0], data.contents[0].Name)
            var finalStruct :DataModel[] = []
            finalStruct.push({
                    path: data.contents[0].Name,
                    id: data.contents[0].Id,
                    parentid: data.contents[0].ParentId,
                    isfolder: data.contents[0].IsFolder,
                    rootname: data.contents[0].Name,
                    name: data.contents[0].Name,
                    size: data.contents[0].Size,
                    dateCreated: HumanReadableDate(data.contents[0].CreatedTime),
                    dateModified: HumanReadableDate(data.contents[0].ModifiedTime),
                    items: dataStructFinal,
                    Thumbnail: data.contents[0].Thumbnail,
                    sharedid: data.contents[0].SharedId,
                    issystem: data.contents[0].IsSystem,
                    issaveasbuilt: data.contents[0].IsSaveAsBuilt,
                    allowfolder: data.contents[0].allowfolder,
                    allowdelete: data.contents[0].allowdelete,
                    allowsave: data.contents[0].allowsave,
                    allowcopy: data.contents[0].allowcopy,
                    allowmove: data.contents[0].allowmove,
                    allowpaste: data.contents[0].allowpaste,
                    allowrename: data.contents[0].allowrename,
                    allowdownload: data.contents[0].allowdownload,
                    allowupload: data.contents[0].allowupload,
                }
            )

            setColumnStructure(finalStruct)
            setReloadColumnViewer(reloadColumnViewer+1)

            setDataLoaded(true)
            setExpanded(getContentIds(data.contents))
        }
        else if (data && data.status === 'success') {
            setDataLoaded(true)
        }
        else {
            setDataLoaded(false)
        }
    }, [data, reloadTab, itemSelected])

    useEffect(()=> {
        if (handleFileOpen && handleFileOpen?.id?.length > 0) {
            setIsLoading(true)
            // event.stopPropagation()
            // event.preventDefault()

            const body = {
                id: handleFileOpen.id,
                filename: handleFileOpen.name
            }
            // downloadDocument.mutateAsync(body)
            axios.post(`api/documentsfile`, body).then((response) => {
                const dataJson = JSON.parse(response.data.jsonString)
                var contentType = 'image/png';
                if (dataJson.fileext === 'png') {
                    contentType = 'image/png'
                } else if (dataJson.fileext === 'pdf') {
                    contentType = 'application/pdf'
                } else if (dataJson.fileext === 'jpeg' || dataJson.fileext === 'jpg' || dataJson.fileext === 'jfif') {
                    contentType = 'image/jpeg'
                } else if (dataJson.fileext === 'docx') {
                    contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                } else if (dataJson.fileext === 'xlsx') {
                    contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                } else if (dataJson.fileext === 'xls') {
                    contentType = 'application/vnd.ms-excel'
                }
                setWatchLogoData(dataJson.filedata)

                const byteCharacters = atob(dataJson.filedata)
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {type: contentType});
                const url = window.URL.createObjectURL(blob);
                setIsLoading(false)
                setWatchLogoDataURL(url);
                setOpenViewer(true)
                setIsLoading(false)
            })
        }
    }, [handleFileOpen])

    const handlebuildTreeClick = async () => {
        const {data} = await axios.put('/api/documentswo', {
            woid: woid
        })
        const parsedData = JSON.parse(data.jsonString)

        if (parsedData && parsedData.contents && parsedData.contents.length > 0) {
            setTreeStructure(createTreeItems(parsedData.contents, ''))
            setDataLoaded(true)
        }
        else if (parsedData && parsedData.status === 'success') {
            setDataLoaded(true)
        }
        else {
            setDataLoaded(false)
        }
    
    }
    const onSave = async (event: any, files: File[], tree: any, topFolderName: any) => {
        setIsLoading(true)
        const fileReader = new FileReader()
        fileReader.onload = function (event) {
            const data = event.target.result as string
            // setValue('logo', data.split(';base64,')[1])
            const body = {
                parentFolderID: tree.Id, // Folder the file is dropped on
                // id: tree.Id,
                rootFolderName: topFolderName, // root folder name
                filename: files[0].name,
                filedata: data.split(';base64,')[1],
                woid: woid,
                mimetype:  files[0].type,
                GUID: "",
            }

            uploadDocument.mutateAsync(body).then((response) => {
                setIsLoading(false)
            })
        }

        fileReader.readAsDataURL(files[0])
        event.stopPropagation()
    }

    const isItemSelected = (itemId) => {
        return itemSelected === itemId
    }

    const getItemColor = (itemId) => {
        return true
    }

    const handleListItemClick = (itemId) => {
        if (itemId == itemSelected) {
            setItemSelected('')
        }
        else {
            setItemSelected(itemId)
        }
    }

    useEffect(() => {
        console.log(itemSelected)
    }, [itemSelected])

    const createListItem = (structure) => {
        const selectedItem = isItemSelected(structure.Id)
        return (
            <ListItem
                key={structure.Id}
                id={structure.Id}
                onContextMenu={(event) => { handleContextMenu(event, structure) }}
            >
                <ListItemButton
                    dense
                    onClick={() => { handleListItemClick(structure.Id) }}
                    selected={selectedItem}
                    sx={{
                        "&.Mui-selected": {
                            borderRadius: "8px",
                            backgroundColor: "blue",
                            color: "white",
                        },
                        "&:hover": selectedItem ? {
                            borderRadius: "8px",
                            color: "white"
                        } : {
                            borderRadius: "8px",
                            color: "white",
                            backgroundColor: "blue",
                        }
                    }}
                >
                    <ListItemIcon>
                        {structure.IsFolder ?
                            <FolderIcon sx={{color: "darkgray", marginRight: '3px'}} />
                            :
                            <FolderIcon sx={{color: "darkgray", marginRight: '3px'}} />
                        }


                        <ListItemText sx={{color: ( selectedItem ? "white" : "black"),
                            "&:hover": selectedItem ? {color: "black"} : {color: "white"}
                        }}
                                      primary={structure.Name}
                        />
                    </ListItemIcon>
                </ListItemButton>
            </ListItem>
        )
    }

    const createTreeItems = (structure, topLevelName) => {
        if (structure && structure.length > 0) {
            return structure.map(tree => {
                if (tree.IsFolder) {
                    const selectedItem = isItemSelected(tree.Id)
                    return (
                        // <Dropzone key={tree.Name} onDrop={(files, rejects, e) => onSave(e, files, tree, topLevelName)} noClick={true}>
                        //     {({ getRootProps,
                        //           getInputProps,
                        //           isDragActive,
                        //           isDragAccept,
                        //           isDragReject,
                        //           acceptedFiles,
                        //           open,
                        //           fileRejections,
                        //       }) => (
                        //         <div {...getRootProps()} className={isDragActive ? styles.dropzoneselect : styles.dropzone}>
                                    <ListItem
                                        key={tree.Id}
                                        id={tree.Id}
                                        onContextMenu={(event) => { handleContextMenu(event, tree) }}
                                    >
                                        <ListItemButton 
                                            dense
                                            onClick={() => { handleListItemClick(tree.Id) }}
                                            selected={selectedItem}
                                            sx={{
                                                "&.Mui-selected": {
                                                    borderRadius: "8px",
                                                    backgroundColor: "blue",
                                                    color: "white",
                                                },
                                                "&:hover": selectedItem ? {
                                                    borderRadius: "8px",
                                                    color: "white"
                                                } : {
                                                    borderRadius: "8px",
                                                    color: "white",
                                                    backgroundColor: "blue",
                                                }
                                            }}
                                        >
                                            <ListItemIcon>
                                                <FolderIcon sx={{color: "darkgray", marginRight: '3px'}} />
                                                <ListItemText sx={{color: ( selectedItem ? "white" : "black"),
                                                    "&:hover": selectedItem ? {color: "black"} : {color: "white"}
                                                }}
                                                    primary={tree.Name}
                                                />
                                            </ListItemIcon>
                                        </ListItemButton>
                                    </ListItem>
                    )
                                    {/*<TreeItem*/}
                                    {/*    style={{color: (isDragActive ? 'blue' : 'black'), border:*/}
                                    {/*            isDragActive && tree.type === 'folder' ? `1px dashed gray` : "none"}}*/}
                                    {/*    key={tree.Id}*/}
                                    {/*    id={tree.Id}*/}
                                    {/*    nodeId={tree.Id}*/}
                                    {/*    label={getTreeCount(tree)}*/}
                                    {/*    onContextMenu={(event) => { handleContextMenu(event, tree) }}*/}
                                    {/*>*/}
                                    {/*    <input {...getInputProps()} />*/}
                                    {/*    {tree.SubItems && tree.SubItems.length > 0 &&*/}
                                    {/*        createTreeItems(tree.SubItems, topLevelName)*/}
                                    {/*    }*/}
                                    {/*</TreeItem>*/}
                                // </div>
                            // )}
                        // </Dropzone>
                    // )
                }
                // console.log(tree)
                return (
                    // TextSnippet
//scotty

                    <ListItem>
                        <ListItemAvatar>
                            <Avatar>
                                <ArticleIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary={tree.Name}
                        />
                        {tree.SubItems && tree.SubItems.length > 0 &&
                            createTreeItems(tree.SubItems, topLevelName)
                        }
                    </ListItem>

                    // <TreeItem icon={<ArticleIcon />} key={tree.Id} nodeId={tree.Id} label={tree.Name+ ' (' + HumanReadableDate(tree.CreatedTime) + ')'}
                    //           draggable={true}
                    //           onDoubleClick={(event) => { handleDoubleClick(event, tree) }}
                    //           onContextMenu={(event) => { handleContextMenu(event, tree) }} >
                    //     {tree.IsFolder && <TreeItem nodeId={""} label={""} />}
                    // </TreeItem>
                )
            })
        }
    }
    
    function HumanReadableDate(isoDateString) {
        if (isoDateString === null) {
            return null
        }
        const date = new Date(isoDateString);
       // Check if the date is valid
        if (isNaN(date.getTime())) {
        // Return a default message or handle the error as needed
            return null;
        }
        const options: Intl.DateTimeFormatOptions = {
            year: 'numeric', // Correct type
            month: '2-digit', // Correct type
            day: '2-digit', // Correct type
            hour: '2-digit', // Correct type
            minute: '2-digit', // Correct type
            timeZoneName: 'short', // Correct type
            hour12: false // Correctly expecting a boolean
          };
        const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
      
        return formattedDate;
    }
    const getTreeCount = (tree) => {
        if (tree && tree.SubItems && tree.SubItems.length > 0 && tree.IsFolder) {
            return tree.Name + ' (' + getCountofContent(tree.SubItems) + ')'
        }
        else {
            return tree.Name
        }
    }

    const getCountofContent = (contents) => {
        var files = 0
        contents.forEach((item) => {
            if (item.IsFolder && item.SubItems && item.SubItems.length > 0) {
                files += getCountofContent(item.SubItems)
            }
            else if (!item.IsFolder) {
                files += 1
            }
        })
        return files
    }

    const getContentIds = (contents) => {
        var ids = []
        contents.forEach((item) => {
            if (item.IsFolder) {
                ids.push(item.Id)
                const idsToAdd = getContentIds(item.SubItems)
                ids = [...ids, ...idsToAdd]
            }
        })
        // console.log(ids)
        return ids
    }

    const [contextMenu, setContextMenu] = React.useState<{
        mouseX: number;
        mouseY: number;
        tree: any;
    } | null>(null);

    const handleContextMenu = (event: React.MouseEvent, tree) => {
        event.stopPropagation()
        event.preventDefault()
        setContextMenu(
            contextMenu === null
                ? {
                    mouseX: event.clientX + 2,
                    mouseY: event.clientY - 6,
                    tree: tree
                }
                : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
                  // Other native context menus might behave different.
                  // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
                null,
        )
    }

    const handleDoubleClick = (event: React.MouseEvent, tree) => {
        setIsLoading(false)
        event.stopPropagation()
        event.preventDefault()

        const body = {
            id: tree.Id,
            filename: tree.Name
        }
        // downloadDocument.mutateAsync(body)
        axios.post(`api/documentsfile`, body).then((response) => {
            const dataJson = JSON.parse(response.data.jsonString)
            var contentType = 'image/png';
            if (dataJson.fileext === 'png') {
                contentType = 'image/png'
            }
            else if (dataJson.fileext === 'pdf') {
                contentType = 'application/pdf'
            }
            else if (dataJson.fileext === 'jpeg' || dataJson.fileext === 'jpg' || dataJson.fileext === 'jfif') {
                contentType = 'image/jpeg'
            }
            else if (dataJson.fileext === 'docx') {
                contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            }
            else if (dataJson.fileext === 'xlsx') {
                contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
            else if (dataJson.fileext === 'xls') {
                contentType = 'application/vnd.ms-excel'
            }
            setWatchLogoData(dataJson.filedata)

            const byteCharacters = atob(dataJson.filedata)
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], {type: contentType});
            const url = window.URL.createObjectURL(blob);
            setIsLoading(false)
            setWatchLogoDataURL(url);
            setOpenViewer(true)
        })
    }

    const handleClose = () => {
        setContextMenu(null);
    }

    const handleCopy = () => {
        setCopyTree(contextMenu.tree)
        setContextMenu(null);
    }

    const handleMove = () => {
        setCopyTree(contextMenu.tree)
        setMoveTree(true)
        setContextMenu(null);
    }

    const handleRename = () => {
        setCopyTree(contextMenu.tree)
        // setMoveTree(true)
        setContextMenu(null);
    }

    const handlePaste = () => {
        setIsLoading(true)
        const copytree = copyTree

        const body = {
            id: copytree.Id,
            toid: contextMenu.tree.Id
        }

        if (moveTree) {
            moveDocument.mutateAsync(body).then((res) => {
                setIsLoading(false)
            })
        }
        else {
            copyDocument.mutateAsync(body).then((res) => {
                setIsLoading(false)
            })
        }
        setMoveTree(false)
        setCopyTree(null)
        setContextMenu(null)
    }

    const handleDownload = () => {
        setIsLoading(true)
        const body = {
            id: contextMenu.tree.Id,
            filename: contextMenu.tree.Name
        }
        const fileName = contextMenu.tree.name
        axios.post(`api/documentsfile`, body).then((response) => {
            const dataJson = JSON.parse(response.data.jsonString)
            setWatchLogoData(dataJson.filedata)
                var contentType = 'image/png';
                if (dataJson.fileext === '.png') {
                    contentType = 'image/png'
                }
                else if (dataJson.fileext === '.pdf') {
                    contentType = 'application/pdf'
                }
                else if (dataJson.fileext === '.jpg' || dataJson.fileext === '.jpg') {
                    contentType = 'image/jpeg'
                }
                else if (dataJson.fileext === '.docx') {
                    contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                }
                else if (dataJson.fileext === '.xlsx') {
                    contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }
                else if (dataJson.fileext === '.xls') {
                    contentType = 'application/vnd.ms-excel'
                }
                const byteCharacters = atob(dataJson.filedata)
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {type: contentType});
                const url = window.URL.createObjectURL(blob);
                setWatchLogoDataURL(url);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
                setIsLoading(false)
        })

        setContextMenu(null);
    }

    const handleDelete = () => {
        setIsLoading(true)
        const body = {
            id: contextMenu.tree.Id,
            filename: contextMenu.tree.Name
        }
        console.log(body)
        deleteDocument.mutateAsync(body).then((response) => {
            setIsLoading(false)
        })
        setContextMenu(null);
    }

    const handleToggle = (event: React.SyntheticEvent, nodeIds: string[]) => {
        setExpanded(nodeIds);
    }

    const getMimeType = (fileext) => {
        fileext = fileext.replace(/\./g, '');
        var contentType = 'image/png';
        if (fileext === 'png') {
            contentType = 'image/png'
        }
        else if (fileext === 'pdf') {
            contentType = 'application/pdf'
        }
        else if (fileext === 'jpg' || fileext === 'jpeg') {
            contentType = 'image/jpeg'
        }
        else if (fileext === 'docx') {
            contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        }
        else if (fileext === 'xlsx') {
            contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
        else if (fileext === 'xls') {
            contentType = 'application/vnd.ms-excel'
        }
        return contentType
    }

    const closeDialog = () => {
        setDialogMsg("")
    }

    return (
        <div className={styles.root}>
            <>
                <Dialog
                    open={dialogMsg.length > 0}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {dialogMsg}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeDialog}>Ok</Button>
                    </DialogActions>
                </Dialog>
            </>
            <Grid
                container
                border={0}
            >
            {dataLoaded && data && !data.contents && !data.allowstructurerecreate &&
                <Grid item border={0} xl={12} md={12} xs={12}>
                    <Box
                        className={styles.box}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        // height={"100%"}
                        // width={"100%"}
                    >
                        <Typography
                            variant="h6"
                            color="primary"
                            component="div">
                            No documents for this work order.
                        </Typography>
                    </Box>
                </Grid>
            }
            {dataLoaded &&
                <Grid item border={0} xl={12} md={12} xs={12}>
                    <ColumnFileViewer columnStructure={columnStructure} isLoading={isLoading} setIsLoading={setIsLoading} woid={woid} reloadColumnViewer={reloadColumnViewer} />
                </Grid>
            }
            </Grid>
            {!dataLoaded &&
                <Grid item border={0} xl={12} md={12} xs={12}>
                    <LoadingBackdrop open={!dataLoaded} />
                </Grid>
            }

            {dataLoaded && data && data.allowstructurerecreate && !treeStructure &&
                <Box
                    className={styles.box}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    // height={"100%"}
                    // width={"100%"}
                >
                     <Button onClick={handlebuildTreeClick}>Build Tree</Button>
                </Box>
            }
        </div>
    )
}

export default DocumentsFileViewerPage
